<template>
    <div class="container">
        <div>
            <h2>Api Logs</h2>
            <hr />
            <b-row class="filters mb-4">
				<b-form-group class="col-md-2" label="Buscar">
                    <b-form-input v-model="filters.search" />
                </b-form-group>

                <b-form-group class="col-md-3" label="Fecha Inicio">
                    <b-form-datepicker
                        locale="es"
                        reset-button
                        v-model="filters.startDate"
                    />
                </b-form-group>

                <b-form-group class="col-md-3" label="Fecha fin">
                    <b-form-datepicker
                        locale="es"
                        reset-button
                        v-model="filters.endDate"
                    />
                </b-form-group>
				<b-form-group class="col-auto" label="Tag">
                    <b-form-select
						v-model="filters.tag"
						:options="apiLogTagsOpts"
						/>
                </b-form-group>
				<b-form-group class="col-auto" label="API">
                    <b-form-select
						v-model="filters.api"
						:options="apiOpts"
						/>
                </b-form-group>
                <b-form-group class="col-auto" label=".">
                    <b-button type="button" variant="primary" @click="search"
                        >Buscar</b-button
                    >
                </b-form-group>
            </b-row>

            <AjaxTable
                permission-show="changelog.show"
                id="external-apilogs-index-list"
                :filters="filtersClean"
                :columns="modelColumns"
				responsive
                resource="external-api-logs"
            >
                <template #cell(show)="row">
                    <b-button
                        @click="fnRequestSelected(row)"
                        size="sm"
						class="ml-2"
                        variant="outline-primary"
                        ><md-icon icon="list" /></b-button
                    >
                </template>
                <template #cell(httpStatus)="row">
                    <b-badge :variant="getVariantHttpCode(row.item.httpStatus)">
                        {{ row.item.httpStatus }}</b-badge
                    >
                </template>
                <template #cell(created_at)="row">
                    {{ dateTimeToLocal(row.item.created_at) }}
                </template>
            </AjaxTable>

            <!-- The modal -->
            <b-modal ref="my-modal-api-request" size="lg">
                <div v-if="this.requestSelected">
                    <b-row>
                        <b-col>
                            <p class="mb-0">
                                <b-badge
                                    class="mr-2 p-2"
                                    :variant="
                                        getVariantHttpCode(
                                            requestSelected.httpStatus
                                        )
                                    "
                                >
                                    {{ requestSelected.httpStatus }}</b-badge
                                >
                                <span class="mr-2"><b>{{ requestSelected.httpMethod.toUpperCase() }} | {{ requestSelected.source.toUpperCase() }} |</b></span>
								<span class="word-break">{{ requestSelected.endpoint }}</span>
                            </p>
                        </b-col>
                    </b-row>
					<hr>
					<p class="mb-0 small word-break bg-light">File: {{requestSelected.origin}}</p>
					<hr>
					<b-alert class="mt-2" variant="primary" show>
						<div class="w-100 d-flex justify-content-between">
							<h5>Request: </h5>
							<span class="text-right small">Requested @ {{dateTimeToLocal(requestSelected.created_at)}}</span>
						</div>
						<pre>{{ requestClean }}</pre>
					</b-alert>

					<b-alert class="mt-2" variant="secondary" show>
						<h5>Response:</h5>
						<pre>{{ responseClean }}</pre>
					</b-alert>
                </div>
            </b-modal>
        </div>
        <hr />
    </div>
</template>

<script>
import AjaxTable from "../../helpers/AjaxTable.vue";
import moment from "moment";

export default {
    components: { AjaxTable },
    data() {
        return {
            filters: {
                search: "",
                api: "jayride",
                startDate: "",
                endDate: "",
                tag: null,
            },
			apiOpts: [
				{ value: 'jayride', text: 'Jayride' },
				{ value: 'booking-dispatchapi', text: 'Booking API Suppliers' },
				{ value: 'booking-webhook', text: 'Booking API Webhook' },
			],
            modelColumns: [
                { key: "id", label: "ID" },
                { key: "source", label: "Source" },
                { key: "httpMethod", label: "Method" },
                { key: "endpoint", label: "Endpoint" },
                { key: "request", label: "Request" },
                { key: "response", label: "Response" },
                { key: "httpStatus", label: "Http status" },
                { key: "tag", label: "Tipo/Tag" },
                { key: "created_at", label: "Created at" },
                { key: "show", label: "Detalles" },
            ],
            requestSelected: null,
        };
    },
    methods: {
        search() {
            this.$root.$emit(
                "bv::refresh::table",
                "external-apilogs-index-list"
            );
        },
        fnRequestSelected(row) {
            this.requestSelected = row.item;
            this.$refs["my-modal-api-request"].show();
        },
        getVariantHttpCode(code) {
            if (code == 200) {
                return "success";
            } else {
                return "danger";
            }
        },
        dateTimeToLocal(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
    },
    computed: {
        filtersClean() {
            return {
                search: this.filters.search,
                api: this.filters.api,
                startDate: this.filters.startDate,
                endDate: this.filters.endDate,
                tag: this.filters.tag,
            };
        },
        requestClean() {
            if (this.requestSelected) {
				return JSON.parse(this.requestSelected.request)
            }
            return null;
        },
		responseClean() {
            if (this.requestSelected) {
				return JSON.parse(this.requestSelected.response)
            }
            return null;
        },
		apiLogTagsOpts() {
			let options = [{ value: null, text: "TODOS" }];
			options.push.apply(
				options,
				this.$root.auxVars.apiLogTags
			);
			return options;
		}
    },
    mounted() {},
};
</script>

<style scope>
.word-break {
	word-break: break-all;
}
</style>
